export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-mail-send-line text-sm w-4 h-4 flex items-center justify-center"></i>
            联系我们
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-4">联系与投稿</h2>
          <p className="text-sm text-foreground-600 mb-8 max-w-lg mx-auto">
            如您有剧集推荐、内容建议或商业合作需求，欢迎通过以下方式与我们取得联系。
            同时也欢迎优质影视内容创作者投稿合作。
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
                <i className="ri-mail-line text-primary-600 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">business@juzitv.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                <i className="ri-edit-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
              <p className="text-xs text-foreground-500">contribute@juzitv.com</p>
            </div>
            <div className="bg-background-50 rounded-xl p-6 border border-background-200/60 cursor-pointer hover:border-primary-200 transition-colors">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-secondary-100 mb-4">
                <i className="ri-question-answer-line text-secondary-600 text-xl w-5 h-5 flex items-center justify-center"></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">在线反馈</h3>
              <p className="text-xs text-foreground-500">support@juzitv.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}